export const BASE_URL = process.env.REACT_APP_API_URL;

export const apiUrl = {
    saveSettings: '/shopify/save_settings',
    getSettings: '/shopify/settings',
}